// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c44ad913","732":"a2ef3060","977":"39870799"}[chunkId] + ".chunk.js";
};